export const paths = {
  INDEX: "",
  EQUIPMENT: "equipment",
  EXPEDITIONS: "expeditions",
  CART: "cart",
  PROFILE: "profile",
  ANY: "*",
};
